package com.taocent.simple.compose.component.richtext.core.internal.platform

actual val isAndroidPlatform: Boolean = false
actual val isWebPlatform: Boolean = true
actual val isIosPlatform: Boolean = false
